import {Plugin} from "chart.js";

const HoverAnnotation: Plugin<'line'> = {
    id: 'hoverAnnotation',
    afterDraw: chart => {
        const activeElement = chart.tooltip?.getActiveElements()[0]?.element

        if (activeElement) {
            let x = activeElement.x;
            let yAxis = chart.scales.y;
            let ctx = chart.ctx;

            ctx.save();
            ctx.beginPath();
            ctx.setLineDash([5, 7])
            ctx.moveTo(x, yAxis.top);
            ctx.lineTo(x, yAxis.bottom);
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'rgb(100,100,100)';
            ctx.stroke();
            ctx.restore();
        }
    }
}

export default HoverAnnotation